import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-truckowner-trip-cancel",
  templateUrl: "./truckowner-trip-cancel.component.html",
  styleUrls: ["./truckowner-trip-cancel.component.css"],
})
export class TruckownerTripCancelComponent implements OnInit {
  token: any;

  constructor(
    private matdialogref: MatDialogRef<TruckownerTripCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private router: Router,
    private services: TruckOwnerService
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
  }
  cancelTrip() {
    this.services.tripCancel(this.data._id, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.snackBar.open("Trip has been completed", "Success", {
            duration: 5000,
          });
          this.matdialogref.close();
          window.location.reload();
        }
      },
      (error) => {
        if (error.status == 403 || 401) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt malformed || jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  cancel() {
    this.matdialogref.close();
  }
}
